




































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ImageZoomer",
  components: { BaseIcon },
  props: {
    id: { type: String, default: "1" },
    active: { type: Boolean, default: false },
    src: { type: String, required: true },
    alt: { type: String, default: "" },
  },
  setup(props) {
    const zoomer = ref();
    const id = computed(() => props.id);

    watch(id, () => {
      if (zoomer.value) {
        zoomer.value.reset();
      }
    });

    const resetZoomer = () => {
      if (zoomer.value.scale <= 1) {
        zoomer.value.reset();
      }
    };

    const onZoomOutClick = () => {
      zoomer.value.zoomOut();
      resetZoomer();
    };

    return { zoomer, onZoomOutClick, resetZoomer };
  },
});
